import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileText, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { href: '#features', label: 'Features' },
    { href: '#how-it-works', label: 'How It Works' },
    { href: '#templates', label: 'Templates' },
    { href: '#pricing', label: 'Pricing' },
  ];

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className="fixed top-0 left-0 right-0 z-50 px-4 py-3 bg-white/90 backdrop-blur-md border-b border-indigo-100 shadow-sm"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center shadow-md">
            <FileText className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold bg-gradient-to-r from-indigo-700 to-violet-700 bg-clip-text text-transparent tracking-tight">
            Format Resume
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-6">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="text-slate-600 hover:text-indigo-600 transition-colors duration-200 text-sm font-medium">
              {item.label}
            </a>
          ))}
        </nav>

        <Button
          asChild
          size="sm"
          className="hidden sm:inline-flex bg-indigo-600 hover:bg-indigo-700 text-white shadow-md shadow-indigo-200"
        >
          <a href="https://thirdeyedata.ai/contact-us/" target="_blank" rel="noreferrer">
            Contact Us
          </a>
        </Button>

        <button
          type="button"
          onClick={() => setIsMobileMenuOpen((open) => !open)}
          className="inline-flex md:hidden items-center justify-center rounded-lg border border-slate-200 p-2 text-slate-700 hover:bg-slate-100"
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden mt-3 rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-lg">
          <div className="flex flex-col gap-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="rounded-lg px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 hover:text-indigo-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://thirdeyedata.ai/contact-us/"
              target="_blank"
              rel="noreferrer"
              onClick={() => setIsMobileMenuOpen(false)}
              className="rounded-lg bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white hover:bg-indigo-700"
            >
              Contact Us
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
};

export default Header;
